import * as React from 'react';
import { msalInstance } from '../..';
import { AiOutlineHome } from 'react-icons/ai';

const style = {
padding: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: 'calc( 100vh - 100px )',
    width: '100%',
    textAlign:'center'
}
/**
 * Sandeep: Unauthorized access page.
 */
class UnauthorizedAccess extends React.PureComponent {
    constructor(props: any) {
        super(props);
    }

    render() {
        return (<>
            <div style={{ width: '100%', float: 'left', padding: '12px 0px', float: 'left', minHeight: '100px', borderBottom: '1px solid' }}>
                <img src={setting.cdnUrl + '/assets/images/logo/logo_trailboss.png'} style={{ maxWidth: '100px' }} />
            </div>
            <div style={style}>
                Something has gone wrong.<br />
                You do not have enough permissions to access the system.<br />
                Please contact administrator.<br />
                <button type="button" className="btn btn-primary" onClick={(e) => { msalInstance.logout() }} style={{ marginTop: '20px', height: '35px', color: '#fcc030' }} >
                    <AiOutlineHome style={{ marginRight:'10px'}} />
                    Continue
                </button>
            </div>
        </>)
    }
};
export default UnauthorizedAccess;